import { render, staticRenderFns } from "./privacy.vue?vue&type=template&id=4b91f287&scoped=true&"
var script = {}
import style0 from "./privacy.vue?vue&type=style&index=0&id=4b91f287&lang=scss&scoped=true&"
import style1 from "./privacy.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b91f287",
  null
  
)

export default component.exports